import React, { useMemo, useState } from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import { Colors, ChartColors } from '../../../constants/Colors.js';
import EmptyStateChart from '../empty-state-chart.js';

const TOPE_INICIAL = 20;

/**
 * Barras horizontales apiladas por cooperativa. Cada serie mantiene su color sin
 * importar el filtro: el color identifica al módulo, no a su posición.
 *
 * series: [{ key, label }]  — el orden fija los colores y el orden de apilado
 * filas:  [{ cooperativa, [key]: n, total }]
 */
const UsoSirioBarras = ({ series, filas, etiquetaTotal = 'registros', altoPorFila = 22 }) => {
  const [verTodas, setVerTodas] = useState(false);

  const conActividad = useMemo(() => filas.filter(fila => series.some(serie => fila[serie.key] > 0)).sort((a, b) => b.total - a.total), [
    filas,
    series,
  ]);

  const visibles = verTodas ? conActividad : conActividad.slice(0, TOPE_INICIAL);
  const ocultas = conActividad.length - visibles.length;

  if (!conActividad.length) {
    return <EmptyStateChart message="Ninguna cooperativa registró actividad en este ciclo" />;
  }

  return (
    <div>
      <ResponsiveContainer width="100%" height={Math.max(180, visibles.length * altoPorFila + 60)}>
        <BarChart data={visibles} layout="vertical" margin={{ top: 0, right: 24, bottom: 0, left: 0 }} barCategoryGap="18%">
          <CartesianGrid horizontal={false} stroke={ChartColors.grid} />
          <XAxis type="number" stroke={ChartColors.axis} tickLine={false} axisLine={false} fontSize={11} />
          <YAxis
            type="category"
            dataKey="cooperativa"
            width={180}
            stroke={ChartColors.axis}
            tickLine={false}
            axisLine={false}
            fontSize={11}
            interval={0}
          />
          <Tooltip
            cursor={{ fill: Colors.black_05 }}
            contentStyle={{ borderRadius: 10, borderColor: Colors.neutral_100, fontSize: 12 }}
            formatter={(valor, nombre) => [valor, nombre]}
          />
          <Legend wrapperStyle={{ fontSize: 12, paddingTop: 8 }} />
          {series.map((serie, i) => (
            <Bar
              key={serie.key}
              dataKey={serie.key}
              name={serie.label}
              stackId="modulos"
              fill={ChartColors.categorical[i % ChartColors.categorical.length]}
              stroke={Colors.white}
              strokeWidth={2}
              isAnimationActive={false}
            />
          ))}
        </BarChart>
      </ResponsiveContainer>

      <div className="d-flex align-items-center justify-content-between flex-wrap mt-2">
        <small style={{ color: Colors.neutral_400 }}>
          {conActividad.length} cooperativas con {etiquetaTotal}
          {ocultas > 0 && ` · se muestran las ${visibles.length} de mayor volumen`}
        </small>
        {conActividad.length > TOPE_INICIAL && (
          <button
            type="button"
            className="btn btn-light"
            style={{ borderRadius: 10, borderColor: Colors.neutral_100, fontSize: '0.8rem' }}
            onClick={() => setVerTodas(valor => !valor)}>
            {verTodas ? `Ver sólo las ${TOPE_INICIAL} principales` : `Ver las ${conActividad.length}`}
          </button>
        )}
      </div>
    </div>
  );
};

export default UsoSirioBarras;
